var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9094 15.3574H1.09126C0.978417 15.3574 0.865206 15.3106 0.777976 15.2192C0.689992 15.127 0.636719 14.9973 0.636719 14.8574V1.14307C0.636719 1.00315 0.689993 0.873371 0.777976 0.781198C0.865205 0.689815 0.978415 0.643066 1.09126 0.643066H10.9094C11.0223 0.643066 11.1355 0.689814 11.2227 0.781198C11.3107 0.873371 11.364 1.00315 11.364 1.14307V14.8574C11.364 14.9973 11.3107 15.127 11.2227 15.2192C11.1355 15.3106 11.0223 15.3574 10.9094 15.3574Z",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 0.285714C0.873914 0.285714 0.665806 0.37602 0.512367 0.536766C0.358928 0.697511 0.272727 0.915529 0.272727 1.14286V14.8571C0.272727 15.0845 0.358928 15.3025 0.512367 15.4632C0.665806 15.624 0.873914 15.7143 1.09091 15.7143H10.9091C11.1261 15.7143 11.3342 15.624 11.4876 15.4632C11.6411 15.3025 11.7273 15.0845 11.7273 14.8571V1.14286C11.7273 0.915529 11.6411 0.697511 11.4876 0.536766C11.3342 0.37602 11.1261 0.285714 10.9091 0.285714H1.09091ZM1.09091 0H10.9091C11.1984 0 11.4759 0.120408 11.6805 0.334735C11.8851 0.549062 12 0.839753 12 1.14286V14.8571C12 15.1602 11.8851 15.4509 11.6805 15.6653C11.4759 15.8796 11.1984 16 10.9091 16H1.09091C0.801582 16 0.524105 15.8796 0.31952 15.6653C0.114935 15.4509 0 15.1602 0 14.8571V1.14286C0 0.839753 0.114935 0.549062 0.31952 0.334735C0.524105 0.120408 0.801582 0 1.09091 0V0Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87109 10.9038L10.1789 10.9038",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87109 8.82715L10.1789 8.82715",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87109 6.75L10.1789 6.75",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02734 4.67285H10.1813",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87109 12.981L10.1789 12.981",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85156,
    y: 2.57715,
    width: 2.11544,
    height: 2.11544,
    stroke: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDocument);
export default __webpack_public_path__ + "static/media/task-document.dc8537755bb8b7b3905aee09a68d3b9c.svg";
export { ForwardRef as ReactComponent };